module.exports = __webpack_public_path__ + "static/img/home_banner_1.864b644.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/home_banner_1.jpg
// module id = NECV
// module chunks = 1